<template>
  <div>
      <div class="row">
        <div class="col s4" v-for="category in categories">
          <div class="card darken-1" :class="[(selectedMetricCategory !== null && category.id == selectedMetricCategory.id) ? blueCard : greyCard]">
            <div class="card-content white-text">
              <span class="card-title center-align">{{ category.display }}</span>
              <p v-show="category.showDetails">{{ category.description }}</p>
            </div>
            <div class="card-action center-align">
              <a style="cursor: pointer" @click="categoryDetailsClick(category)">
                <span v-if="!category.showDetails">Show Details</span>
                <span v-else>Hide Details</span>
              </a>
              <a class="btn" @click="selectCategory(category)">Select</a>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'metric-selector',
  data: function () {
    return {
      blueCard: 'blue',
      greyCard: 'grey',
      FCMDetails: false,
      TCMDetails: false,
      HCMDetails: false
    }
  },
  computed: mapState([
    'selectedMetricCategory',
    'categories'
  ]),
  methods: {
    selectCategory: function (category) {
      this.$store.commit('metricCategory', category)
    },
    categoryDetailsClick: function (category) {
      this.$store.commit('metricCategoryDetails', category)
    }
  }
}
</script>
<style>

.metric-category {
  border: 3px solid black;
  height: 3rem;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 10px;
  margin-right: 1rem;
  margin-left: 1rem;
  width: 100%;
  background-color: lightgrey;
}

.metric-text {
  font-weight: bold;
  width: 100%;
}

.chosen_metric {
  border: 3px solid green;
  background-color: lightyellow;

}
</style>



// WEBPACK FOOTER //
// MetricSelector.vue?368699de